export enum LoadingState {
    LOADING,
    OK,
    ERROR
}